import React from 'react'
import { useIntl } from 'react-intl'
import { PiCalendarBlank } from 'react-icons/pi'

interface NoPtoBalanceStateProps {
  balanceResetDate: string
}

export const NoPtoBalanceState: React.FC<NoPtoBalanceStateProps> = ({ balanceResetDate }) => {
  const { formatMessage } = useIntl()

  return (
    <div className="checkin-card checkin-card--no-balance">
      <div className="checkin-header">
        <span className="checkin-emoji" role="img" aria-label="celebration">
          🎉
        </span>
        <h3 className="checkin-title">{formatMessage({ id: 'energyLevel.noPtoBalance.title' })}</h3>
      </div>
      <p className="checkin-description">{formatMessage({ id: 'energyLevel.noPtoBalance.description' })}</p>

      <div className="checkin-notice">
        <PiCalendarBlank className="notice-icon" />
        <span>{formatMessage({ id: 'energyLevel.noPtoBalance.resetDate' }, { date: <strong key="date">{balanceResetDate}</strong> })}</span>
      </div>
    </div>
  )
}

export default NoPtoBalanceState
